import styled from "styled-components";
import colors from "assets/scss/colors.scss";

const StyleWrapper = styled.div`
.p-inputtext, .p-dropdown, .p-calendar, .p-inputnumber{
    border: none;
    width: 100%;
}
.z-index-0 {
  z-index: 0;
}

.accordion-header{
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 32px 12px 32px 24px;
        // background: #FFFFFF;
        border-radius: 8px 8px 0px 0px;
        width:100%;
        cursor:pointer;
        .arrow.down{
            transform: rotate(180deg); 
        }
        .arrow.up{
            transform: rotate(0deg); 
        }

        &.sub{
            padding: 1rem;
            border-radius: 8px;
        }
        &.opened{
            border-radius: 8px 8px 0px 0px;
        }
        h5{
            font-weight: 800; font-size: 1.25rem; color: #4C565C;
        }
}

    .infos-section{
        display: block;
        flex-direction: column;
        align-items: flex-start;
        // padding: 24px;
        background: #FFFFFF;
        box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
        border-radius: 0px 0px 12px 12px;
        width:100%;
        .info-card{
            width:100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 1rem 1.5rem;
            background: #F2F3F5;
            border-radius: 8px;
            &.form_card{
                display: block;
            }
            h5{
                font-weight: 800;
                font-size: 16px;
                line-height: 120%;
                color: #455560;
            }
            .increment-decrement-ar .p-inputnumber-button-up{
                right: unset;
                left: 5px;
            }
            .increment-decrement-ar .p-inputnumber-button-down{
                right: unset;
                left: 65px;
            }
        }

        .add-info{
            .pi-plus{
                background:transparent;
                color:white;
                font-weight:bold;
            }
        }
    }


    .actions{
        display: flex;
        width: 100%;
        justify-content: flex-end;
        margin-top: 1rem;
        button{
          display: inline-flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          padding: 0px 24px;
          outline:none;
          box-shadow:none;
          border-radius: 5px;
          border:none;
          height: 42px;
          &.save-btn{
            background: ${colors["bright-purple"]};
            border-radius: 8px;
          }
          &.close-btn{
            border:none;
            color:#4C565C;
            margin:0 10px;
            &:hover,&:focus,&:active{
              background:transparent;
              border:none;
              color:#4C565C;
            }
          }
        }
      }
    }
    .phone-input{
        .keys{
            width: 32%;
            border-radius: 5px 0 0 5px;
              background: #F2F3F5;
              .p-dropdown-trigger-icon{
                  font-size:12px;
                  font-weight:bold;
              }
        }
        .values{
            width:85%;
            border-radius: 0 5px 5px 0;
  
        }
    }
    .radio_group_wrapper{
        padding: 1rem 0;
        display: flex;
        gap: 1rem;
        .radio_wrapper{
            display: inline-flex;
            gap: .5rem;
        }
    }
    .p-inputnumber{
        position: relative;
        .p-inputnumber-button-up {
            background: #F2F3F5 !important;
            border-radius: 4px;
            border-color: #F2F3F5;
            position: absolute;
            z-index: 5;
            right: 5px;
            top: 3px;
            .pi {
                background: transparent;
                color: #1D252D;
                font-weight: bold;
            }
        }
        .p-inputnumber-button-down {
            background: #F2F3F5;
            border-radius: 4px;
            border-color: #F2F3F5;
            position: absolute;
            z-index: 5;
            right: 65px;
            top: 3px;
            .pi {
                background: transparent;
                color: #1D252D;
                font-weight: bold;
            }
        }
    }
    
    .fm-tawuniya{
        .p-dropdown-label.p-inputtext{
            font-family: 'tawuniya';
        }
    }
    .ar{
        .p-float-label input:focus ~ label, .p-float-label input:-webkit-autofill ~ label, .p-float-label input.p-filled ~ label, .p-float-label textarea:focus ~ label, .p-float-label textarea.p-filled ~ label, .p-float-label .p-inputwrapper-focus ~ label, .p-float-label .p-inputwrapper-filled ~ label{
            right:0;
            left:auto;
        }
    }

    &.ar{
        .p-float-label input:focus ~ label, .p-float-label input:-webkit-autofill ~ label, .p-float-label input.p-filled ~ label, .p-float-label textarea:focus ~ label, .p-float-label textarea.p-filled ~ label, .p-float-label .p-inputwrapper-focus ~ label, .p-float-label .p-inputwrapper-filled ~ label{
            right:0;
            left:auto;
        }
    }
    @media only screen and (max-width: 786px){
        .infos-section{
            .info-card{
                flex-direction: column;
                align-items: start;
            }
        }
        .phone-input{
            .keys{
                width:40%;
            }
          }
    }
    .showar{
        right:0 !important;
        left:auto !important
    }
    .showen{
        right:auto !important;
        left:0 !important
    }
    .p-radiobutton .p-radiobutton-box.p-highlight{
        border-color: ${props => `${props.businessColor} !important`};
        background: ${props => `${props.businessColor} !important`};
      }
      .p-radiobutton .p-radiobutton-box:not(.p-disabled):not(.p-highlight):hover {
        border-color: ${props => props.businessColor};
      }
`;

export default StyleWrapper;
